import { Injectable } from "@angular/core";
import { Http, Response, Headers, RequestOptions } from "@angular/http";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { analyzeAndValidateNgModules, Type } from "@angular/compiler";
import { Observable, Subject } from "rxjs";
import { map } from "rxjs/operators";
import {
  prepareSyntheticListenerFunctionName,
  prepareSyntheticListenerName
} from "@angular/compiler/src/render3/util";

@Injectable({
  providedIn: "root"
})
export class MedicinService {
  private subject = new Subject<any>();
  APIResponse: any;
  // BaseURL1: string = "https://hdrx.23byt.es/api/v1/";
  // BaseURL2: string = "https://hdrx.23byt.es/api/v2/";
  // BaseURL3: string = "https://hdrx.23byt.es/api/v3/";
  BaseURL1: string = "https://littleangelhands-api.rxhacker.com/api/v1/";
  BaseURL2: string = "https://littleangelhands-api.rxhacker.com/api/v2/";
  BaseURL3: string = "https://littleangelhands-api.rxhacker.com/api/v3/";
  GeoBaseURL: string = "https://maps.googleapis.com/maps/api/geocode/json?";
  GeoAPIKey = "AIzaSyC46tn0xWqdGs1bD60z4cFakEh510tR3dw";
  DistanceBaseURL =
    "https://maps.googleapis.com/maps/api/distancematrix/json?units=imperial&";
  DistanceAPIKey = "AIzaSyC46tn0xWqdGs1bD60z4cFakEh510tR3dw";

  // https://maps.googleapis.com/maps/api/js?key=AIzaSyC46tn0xWqdGs1bD60z4cFakEh510tR3dw

  showloginbox = false;
  signup_fields = false;
  signin_fields = false;

  constructor(public http1: HttpClient, public http: Http) { }
  //Default Card Data
  GetDefaultCard(AppName) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8');
    return this.http.post(this.BaseURL2 + 'defaultcard', 'AppName=' + AppName +'&AppType=WebApp',
      { headers: headers });
  }
  //check login status last time
  lastLoginStatus(getUserId,getUserEmail) {
    let headers = new Headers();
    headers.append(
      "Content-Type",
      "application/x-www-form-urlencoded; charset=utf-8"
    );
    return this.http.post(this.BaseURL2 + "VerifyUser", "UserId=" + getUserId+"&UserEmail="+getUserEmail,  { headers: headers })
  }
  SearchDrugList(searchtext) {
    var Encode_DrugName = encodeURIComponent(searchtext);
    let headers = new Headers();
    headers.append(
      "Content-Type",
      "application/x-www-form-urlencoded; charset=utf-8"
    );
    return this.http.post(
      this.BaseURL3 + "searchdrug",
      "stext=" + Encode_DrugName,
      {
        headers: headers,
      }
    );
  }
  GetPopularDrug() {
    let headers = new Headers();
    headers.append(
      "Content-Type",
      "application/x-www-form-urlencoded; charset=utf-8"
    );
    return this.http.post(this.BaseURL3 + "populardrug", "DrugName=" + "test", {
      headers: headers,
    });
  }
  GetDrugDetails(DrugName) {
    var Encode_DrugName = encodeURIComponent(DrugName);
    let headers = new Headers();
    headers.append(
      "Content-Type",
      "application/x-www-form-urlencoded; charset=utf-8"
    );
    return this.http.post(
      this.BaseURL3 + "drugcomponents",
      "DrugName=" + Encode_DrugName,
      { headers: headers }
    );
  }
  GetCoordinatebyzip(ZipCode) {
    return this.http.get(
      this.GeoBaseURL + "address=" + ZipCode + "&key=" + this.GeoAPIKey
    );
  }
  GetLocationByLatLongWithSensor(Lat, Long) {
    return this.http.get(
      this.GeoBaseURL +
      "latlng=" +
      Lat +
      "," +
      Long +
      "&sensor=true&key=" +
      this.GeoAPIKey
    );
  }
  GetPharmacyList(
    Lat,
    Long,
    GPId,
    Quantity,
    Dosage,
    Type,
    MultiSource,
    DrugName,
    UserId,
    ZipCode,
    UserLocation,
    ResponseType
  ) {
    var Encode_DrugName = encodeURIComponent(DrugName);
    let headers = new Headers();
    headers.append(
      "Content-Type",
      "application/x-www-form-urlencoded; charset=utf-8"
    );
    return this.http.post(
      this.BaseURL3 + "pharmacy",
      "Lat=" +
      Lat +
      "&Long=" +
      Long +
      "&GpId=" +
      GPId +
      "&Quant=" +
      window.localStorage.getItem('lahrx_DrugQuant') +
      "&Dosage=" +
      Dosage +
      "&Type=" +
      Type +
      "&MultiSource=" +
      MultiSource +
      "&DrugName=" +
      Encode_DrugName +
      "&UserId=" +
      UserId +
      "&ZipCode=" +
      ZipCode +
      "&Userlocation=" +
      UserLocation +
      "&ResponseType=" +
      ResponseType +
      "&NDCCode=" + window.localStorage.getItem('lahrx_ndccode') +
      "&DisplayQuant=" + window.localStorage.getItem('lahrx_displayquantity'),
      { headers: headers }
    );
  }
  CreateAccount(EmailId, Password, groupnumber) {
    try {
      let headers = new Headers();
      headers.append(
        "Content-Type",
        "application/x-www-form-urlencoded; charset=utf-8"
      );
      return this.http.post(
        this.BaseURL1 + "signup",
        "email=" +
        EmailId +
        "&password=" +
        Password +
        "&groupnumber=" +
        groupnumber,
        { headers: headers }
      );
    } catch { }
  }

  LoginAccount(EmailId, Password) {
    let headers = new Headers();
    headers.append(
      "Content-Type",
      "application/x-www-form-urlencoded; charset=utf-8"
    );
    return this.http.post(
      this.BaseURL1 + "signin",
      "email=" + EmailId + "&password=" + Password,
      { headers: headers }
    );
  }

  ForgotPassword(EmailId) {
    let headers = new Headers();
    headers.append(
      "Content-Type",
      "application/x-www-form-urlencoded; charset=utf-8"
    );
    return this.http.post(this.BaseURL1 + "passwordreset", "email=" + EmailId, {
      headers: headers
    });
  }
  SaveUserCards(
    UserId,
    UserCharId,
    PharmacyName,
    PharmacyType,
    DrugName,
    Price,
    Quantity,
    Dose,
    Form,
    PharmacyPhone,
    Address1,
    Address2,
    GpId,
    MultiSource,
    Bin,
    Pcn,
    DialNumber,
    Plogo
  ) {
    var Encode_DrugName = encodeURIComponent(DrugName);
    var Encode_PharmacyName = encodeURIComponent(PharmacyName);
    let headers = new Headers();
    headers.append(
      "Content-Type",
      "application/x-www-form-urlencoded; charset=utf-8"
    );
    return this.http.post(
      this.BaseURL1 + "card",
      "UserId=" +
      UserId +
      "&UserCharId=" +
      UserCharId +
      "&PharmacyName=" +
      Encode_PharmacyName +
      "&PharmacyType=" +
      PharmacyType +
      "&DrugName=" +
      Encode_DrugName +
      "&Price=" +
      Price +
      "&Quantity=" +
      Quantity +
      "&Dose=" +
      Dose +
      "&Form=" +
      Form +
      "&PharmacyPhone=" +
      PharmacyPhone +
      "&Address1=" +
      Address1 +
      "&Address2=" +
      Address2 +
      "&GPId=" +
      GpId +
      '&Bin='+
      Bin +
      '&Pcn='+
      Pcn+
      '&Pbmphone='+
      DialNumber +
      '&Plogo='+
      Plogo +
      "&MultiSource=" +
      MultiSource,
      { headers: headers }
    );
  }

  GetUserCards(UserId) {
    let headers = new Headers();
    headers.append(
      "Content-Type",
      "application/x-www-form-urlencoded; charset=utf-8"
    );
    return this.http.post(this.BaseURL1 + "usercard", "UserId=" + UserId, {
      headers: headers
    });
  }
  RemoveSavedCard(UserId, CardId) {
    let headers = new Headers();
    headers.append(
      "Content-Type",
      "application/x-www-form-urlencoded; charset=utf-8"
    );
    return this.http.post(
      this.BaseURL2 + "RemoveCard",
      "UserId=" + UserId + "&cardId=" + CardId,
      { headers: headers }
    );
  }

  SaveUserShareCard(
    UserId,
    MemeberId,
    DrugName,
    Quantity,
    DrugForm,
    DrugDose,
    DrugPrice,
    PharmacyName,
    Address1,
    Address2,
    PPhone,
    Bin,
    PCN,
    GroupNumber,
    UserEmail,
    PHelpLine,
    Localuser
  ) {
    var Encode_DrugName = encodeURIComponent(DrugName);
    var Encode_PharmacyName = encodeURIComponent(PharmacyName);
    let headers = new Headers();
    headers.append(
      "Content-Type",
      "application/x-www-form-urlencoded; charset=utf-8"
    );
    return this.http.post(
      this.BaseURL2 + "dc",
      "UId=" +
      UserId +
      "&MId=" +
      MemeberId +
      "&Dname=" +
      Encode_DrugName +
      "&Q=" +
      Quantity +
      "&Form=" +
      DrugForm +
      "&Dose=" +
      DrugDose +
      "&Price=" +
      DrugPrice +
      "&Pname=" +
      Encode_PharmacyName +
      "&Ad1=" +
      Address1 +
      "&Ad2=" +
      Address2 +
      "&Phone=" +
      PPhone +
      "&Bin=" +
      Bin +
      "&PCN=" +
      PCN +
      "&GN=" +
      GroupNumber +
      "&Email=" +
      UserEmail +
      "&HL=" +
      PHelpLine +
      "&User=" +
      Localuser,
      { headers: headers }
    );
  }
  RemoveDiscountCard(UserId, MemeberId, DrugName, Quantity, DrugForm, DrugDose, DrugPrice, PharmacyName, Address1, Address2, PPhone, MultiSource, PType) {
    var Encode_DrugName = encodeURIComponent(DrugName);
    var Encode_PharmacyName = encodeURIComponent(PharmacyName);
    let headers = new Headers();
    headers.append(
      "Content-Type",
      "application/x-www-form-urlencoded; charset=utf-8"
    );
    return this.http.post(this.BaseURL2 + "RemoveDiscountCard",
      "UId=" + UserId + "&MId=" + MemeberId + "&Dname=" + Encode_DrugName + "&Q=" + Quantity + "&Form=" + DrugForm + "&Dose=" + DrugDose + "&Price=" + DrugPrice + "&Pname=" + Encode_PharmacyName + "&Ad1=" + Address1 + "&Ad2=" + Address2 + "&Phone=" + PPhone + "&Ms=" + MultiSource + "&Type=" + PType,
      { headers: headers }
    );
  }
  GNValidate(groupnumber) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8');
    return this.http.post(this.BaseURL2 + 'groupnumber', 'stext=' + groupnumber,
      { headers: headers });
  }
  UpdateGroupNumber(UserId, GroupNumber) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8');
    return this.http.post(this.BaseURL2 + 'updategn', 'UserId=' + UserId + '&UserGN=' + GroupNumber,
      { headers: headers });
  }
  PushCardList() {
    try {
      if (window.localStorage.getItem('lahrx_CardListLocally') != null || window.localStorage.getItem('lahrx_CardListLocally') != undefined) {
        let CardListData = JSON.parse(window.localStorage.getItem('lahrx_CardListLocally'));
        for (let x3 of CardListData) {
          this.SaveUserCards(window.localStorage.getItem('lahrx_UserId'), window.localStorage.getItem('lahrx_UserCharId'), x3.PharmacyName, x3.PharmacyType, x3.DrugName, x3.Price, x3.Quantity, x3.Dose, x3.Form, x3.PharmacyPhone, x3.Address1, x3.Address2, x3.GPId, x3.MultiSource,x3.Bin,x3.PCN,x3.PBMPhone,x3.LogoLink).pipe(map(res => res.json()))
            .subscribe(data => {
            })
        }
        window.localStorage.setItem('lahrx_CardListLocally', null);
      }
    }
    catch{ }
  }
  ResetPassword(userid, cpassword, npassword) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8');
    return this.http.post(this.BaseURL1 + 'passwordupdate', 'UserId=' + userid + '&CurrentPassword=' + cpassword + '&NewPassword=' + npassword,
      { headers: headers });
  }
  RequestOTP_Forgotpassword(EmailId) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8');
    return this.http.post(this.BaseURL1 + 'otprequest', 'useremail=' + EmailId,
      { headers: headers });
  }
  VerifyOTP_Forgotpassword(OTP, UserId) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8');
    return this.http.post(this.BaseURL1 + 'otpverify', 'OTP=' + OTP + '&UserId=' + UserId,
      { headers: headers });
  }
  VerifyOTP_Resetpassword(UserId, Password) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8');
    return this.http.post(this.BaseURL1 + 'forgetresetpassword', 'UserId=' + UserId + '&Password=' + Password,
      { headers: headers });
  }
  GetWhiteParams() {
    let headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8');
    return this.http.post(this.BaseURL2 + 'whiteparam', 'stext=' + 'test',
      { headers: headers });
  }
  IsNullOrEmptyField(input: string) {
    if (input == "" || input == undefined || input == null) return true;
    else return false;
  }

  Setsignup(box, signup, signin) {
    this.showloginbox = box;
    this.signup_fields = signup;
    this.signin_fields = signin;
  }
  Getsignup() {
    let xyz: any = [];
    return (xyz = [this.showloginbox, this.signup_fields, this.signin_fields]);
  }

  sendMessage(message: string) {
    this.subject.next({ text: message });
  }

  clearMessages() {
    this.subject.next();
  }

  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }
}